import types from '../../actions.types';
import { getCompanies } from '../../../api-calls/companies/companies'

const { PENDING, SUCCESS, FAILED } = types.companies;

export default () => {

  return dispatch => {

    dispatch({ type: PENDING });

    return getCompanies().then(data => {
      dispatch({
        type: SUCCESS,
        data
      });
    }).catch(error => {
      dispatch({
        type: FAILED,
        error
      });
    });

  }
}

